/* BDF SEARCH + LANGUAGE — interaction layer */
(function(){
  'use strict';
  function qs(s,c){return (c||document).querySelector(s)}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  function focusables(root){return qsa('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',root).filter(function(el){return el.offsetParent!==null})}
  function escapeHtml(str){return String(str||'').replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[c]})}
  var active=null,previousFocus=null,aborter=null,timer=null;
  function lock(on){document.documentElement.classList.toggle('bdf-global-overlay-open',!!on)}
  function openOverlay(name){
    closeOverlay();
    var overlay=qs(name==='search'?'[data-bdf-search-overlay]':'[data-bdf-language-overlay]');
    if(!overlay)return;
    previousFocus=document.activeElement;active=overlay;overlay.classList.add('is-open');overlay.setAttribute('aria-hidden','false');lock(true);
    var target=name==='search'?qs('[data-bdf-search-input]',overlay):qs('.bdf-language-option:not([disabled])',overlay);
    if(target)setTimeout(function(){target.focus()},35);
  }
  function closeOverlay(){
    if(!active)return;
    active.classList.remove('is-open');active.setAttribute('aria-hidden','true');active=null;lock(false);
    if(previousFocus&&previousFocus.focus)previousFocus.focus();
  }
  function trap(e){
    if(!active)return;
    if(e.key==='Escape'){e.preventDefault();closeOverlay();return}
    if(e.key!=='Tab')return;
    var list=focusables(active);if(!list.length)return;
    var first=list[0],last=list[list.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
  }
  function injectDesktop(){
    var source=qs('[data-bdf-header-enhancements]'),actions=qs('.bdf-header-actions');
    if(!source||!actions)return;
    source.hidden=false;
    var search=qs('[data-bdf-search-open]',source),lang=qs('[data-bdf-language-open]',source),fav=qs('.bdf-favorite-top',actions);
    if(search){if(fav)actions.insertBefore(search,fav);else actions.insertBefore(search,actions.firstChild)}
    if(lang)actions.appendChild(lang);
    source.remove();
  }
  function mobileRow(label,icon,handler){
    var g=document.createElement('div');g.className='bdf-mobile-group bdf-mobile-search-language';
    g.innerHTML='<div class="bdf-mobile-parent-row"><button type="button" class="bdf-mobile-utility-btn">'+icon+'<span>'+label+'</span></button></div>';
    qs('button',g).addEventListener('click',handler);return g;
  }
  function injectMobile(){
    var body=qs('#bdfMobileMenu .bdf-mobile-body');if(!body||qs('[data-bdf-mobile-utilities]',body))return;
    var wrap=document.createElement('div');wrap.setAttribute('data-bdf-mobile-utilities','');
    var searchIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.2 4.2"/></svg>';
    var globeIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.2 2.5 3.4 5.5 3.4 9S14.2 18.5 12 21M12 3C9.8 5.5 8.6 8.5 8.6 12s1.2 6.5 3.4 9"/></svg>';
    wrap.appendChild(mobileRow('RECHERCHER',searchIcon,function(){var close=qs('.bdf-mobile-close');if(close)close.click();setTimeout(function(){openOverlay('search')},120)}));
    wrap.appendChild(mobileRow('LANGUE',globeIcon,function(){var close=qs('.bdf-mobile-close');if(close)close.click();setTimeout(function(){openOverlay('language')},120)}));
    body.appendChild(wrap);
  }
  function renderPredictive(data,q){
    var box=qs('[data-bdf-predictive]');if(!box)return;
    var resources=data&&data.resources&&data.resources.results?data.resources.results:{};
    var items=[];
    ['products','articles','pages'].forEach(function(type){
      (resources[type]||[]).forEach(function(item){items.push({type:type,item:item})});
    });
    if(!items.length){box.innerHTML='<div class="bdf-predictive__status">Aucun résultat immédiat. Lance la recherche complète pour élargir.</div>';return}
    var html='<div class="bdf-predictive__grid">';
    items.slice(0,6).forEach(function(row){
      var i=row.item,type=row.type,label=type==='products'?'PRODUIT':type==='articles'?'LE TERRAIN':'PAGE';
      var img=(i.featured_image&&i.featured_image.url)||i.image||'';
      var media=img?'<span class="bdf-predictive__media"><img src="'+escapeHtml(img)+'" alt="" loading="lazy"></span>':'<span class="bdf-predictive__media bdf-predictive__media--empty">BDF</span>';
      var price='';if(type==='products'&&i.price)price='<span class="bdf-predictive__price">'+escapeHtml(i.price)+'</span>';
      html+='<a class="bdf-predictive__item" href="'+escapeHtml(i.url||'#')+'">'+media+'<span class="bdf-predictive__copy"><span class="bdf-predictive__type">'+label+'</span><span class="bdf-predictive__title">'+escapeHtml(i.title)+'</span>'+price+'</span></a>';
    });
    html+='</div><a class="bdf-predictive__all" href="/search?q='+encodeURIComponent(q)+'&type=product%2Carticle%2Cpage">VOIR TOUS LES RÉSULTATS →</a>';box.innerHTML=html;
  }
  function predictive(q){
    var box=qs('[data-bdf-predictive]');if(!box)return;
    q=(q||'').trim();if(q.length<2){box.innerHTML='';return}
    if(aborter)aborter.abort();aborter=new AbortController();
    box.innerHTML='<div class="bdf-predictive__status">Recherche en cours…</div>';
    var url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,body';
    fetch(url,{headers:{Accept:'application/json'},signal:aborter.signal}).then(function(r){if(!r.ok)throw new Error('search');return r.json()}).then(function(data){renderPredictive(data,q)}).catch(function(err){if(err.name==='AbortError')return;box.innerHTML='<div class="bdf-predictive__status">Recherche instantanée indisponible. Utilise le bouton Rechercher.</div>'});
  }
  function init(){
    injectDesktop();injectMobile();
    qsa('[data-bdf-search-open]').forEach(function(b){b.addEventListener('click',function(){openOverlay('search')})});
    qsa('[data-bdf-language-open]').forEach(function(b){b.addEventListener('click',function(){openOverlay('language')})});
    qsa('[data-bdf-search-close],[data-bdf-language-close]').forEach(function(b){b.addEventListener('click',closeOverlay)});
    qsa('[data-bdf-language-value]').forEach(function(btn){btn.addEventListener('click',function(){var input=qs('[data-bdf-language-code]',btn.form);if(input)input.value=btn.getAttribute('data-bdf-language-value')})});
    var input=qs('[data-bdf-search-input]');if(input)input.addEventListener('input',function(){clearTimeout(timer);var value=this.value;timer=setTimeout(function(){predictive(value)},180)});
    document.addEventListener('keydown',trap);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
}());